export default __webpack_public_path__ + "static/media/logo_spch_60.429239e9.png";